"use client";

import React from "react";
import { Microscope, HardHat, ArrowRight, Building2, GraduationCap, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
export default function AcademicPracticalFoundation() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const pillars = [{
    id: "academic",
    title: "Nghiên cứu Học thuật",
    icon: GraduationCap,
    description: "Hợp tác chặt chẽ với Đại học Xây dựng Hà Nội, chúng tôi tiên phong trong việc ứng dụng các nghiên cứu khoa học vào thực tiễn xây dựng.",
    features: ["Chuyển giao công nghệ mới", "Đào tạo chuyên gia cao cấp", "Hợp tác quốc tế"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/academic_research_lab.webp"
  }, {
    id: "practical",
    title: "Thực tiễn Công trình",
    icon: HardHat,
    description: "Biến những bản vẽ kỹ thuật thành hiện thực với quy trình quản lý chất lượng nghiêm ngặt và đội ngũ kỹ sư giàu kinh nghiệm.",
    features: ["Tư vấn giám sát chuyên sâu", "Quản lý dự án BIM", "Giải pháp kết cấu tối ưu"],
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/construction_site_practical.png"
  }];
  return;
}